import {Component, OnInit} from '@angular/core';
import {Timecard} from '../../../_models/timecard';
import {TimecardService} from '../../../_services/timecard.service';
import {OrganizationService} from '../../../_services/organization.service';
import {LoadingService} from '../../../_services/loading.service';
import {ModalController} from '@ionic/angular';
import {BaseTimecardWidgetComponent} from '../base-timecard-widget.component';
import {ColumnFormatterService} from '../../../_services/column-formatter.service';

@Component({
    selector: 'bb-active-timecards-widget',
    templateUrl: './active-timecards-widget.component.html',
    styleUrls: ['./active-timecards-widget.component.scss'],
})
export class ActiveTimecardsWidgetComponent extends BaseTimecardWidgetComponent implements OnInit {

    constructor(
        timecardService: TimecardService,
        organizationService: OrganizationService,
        loadingService: LoadingService,
        modalController: ModalController,
        columnFormatterService: ColumnFormatterService
    ) {
        super(timecardService,
            organizationService,
            loadingService,
            modalController,
            columnFormatterService);
    }

    ngOnInit(): void {
        this.timecardService.event.subscribe(t => this.refresh());
    }

    refresh() {
        if (!!this.organization) {
            this.timecardService.active(this.widget.parentId, this.selectedPickupLocations)
                .subscribe((t: Timecard[]) => {
                    this.timecards = t;
                    this.loading = false;
                    this.error = false;
                    this.dataReady.emit();
                }, () => {
                    this.error = true;
                    this.loading = false;
                    this.timecards = null;
                });
        }
    }
}
